import { cn } from "../../../../../lib/utils";
import { EMPTY_VALUE } from "../constants";

interface PlaceholderValueProps {
  className?: string;
}

const PlaceholderValue = ({ className }: PlaceholderValueProps) => (
  <span className={cn("text-neutral-alpha-300", className)}>{EMPTY_VALUE}</span>
);

export { PlaceholderValue };
